var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterieurVoitureGarage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3001.78 3000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-45,.cls-47,.cls-52{fill:none;}.cls-2{fill:url(#D\xE9grad\xE9_sans_nom_82);}.cls-3{fill:url(#D\xE9grad\xE9_sans_nom_39);}.cls-4{fill:url(#D\xE9grad\xE9_sans_nom_22);}.cls-5{fill:#ce5e36;}.cls-6{fill:url(#D\xE9grad\xE9_sans_nom_61);}.cls-7{fill:url(#D\xE9grad\xE9_sans_nom_22-2);}.cls-8{fill:url(#D\xE9grad\xE9_sans_nom_22-3);}.cls-9{fill:url(#D\xE9grad\xE9_sans_nom_40);}.cls-10{fill:url(#D\xE9grad\xE9_sans_nom_61-2);}.cls-11{fill:url(#D\xE9grad\xE9_sans_nom_22-4);}.cls-12{fill:url(#D\xE9grad\xE9_sans_nom_22-5);}.cls-13{fill:url(#D\xE9grad\xE9_sans_nom_40-2);}.cls-14{fill:url(#D\xE9grad\xE9_sans_nom_61-3);}.cls-15{fill:url(#D\xE9grad\xE9_sans_nom_22-6);}.cls-16{fill:url(#D\xE9grad\xE9_sans_nom_22-7);}.cls-17{fill:url(#D\xE9grad\xE9_sans_nom_40-3);}.cls-18{fill:url(#D\xE9grad\xE9_sans_nom_61-4);}.cls-19{fill:url(#D\xE9grad\xE9_sans_nom_22-8);}.cls-20{fill:url(#D\xE9grad\xE9_sans_nom_22-9);}.cls-21{fill:url(#D\xE9grad\xE9_sans_nom_40-4);}.cls-22{fill:#66926d;}.cls-23{fill:#232728;}.cls-24{fill:#b8b8b8;}.cls-25{fill:#686d6d;}.cls-26{fill:#bddff2;opacity:0.32;}.cls-27{fill:url(#D\xE9grad\xE9_sans_nom_95);}.cls-28{clip-path:url(#clip-path);}.cls-29{fill:url(#D\xE9grad\xE9_sans_nom_109);}.cls-30{fill:#4e5254;}.cls-31{clip-path:url(#clip-path-2);}.cls-32{fill:url(#D\xE9grad\xE9_sans_nom_96);}.cls-33{fill:url(#D\xE9grad\xE9_sans_nom_101);}.cls-34{fill:url(#D\xE9grad\xE9_sans_nom_36);}.cls-35{fill:url(#D\xE9grad\xE9_sans_nom_36-2);}.cls-36{fill:url(#D\xE9grad\xE9_sans_nom_80);}.cls-37{fill:#c7ced3;stroke-width:10px;}.cls-37,.cls-45,.cls-47{stroke:#272b2e;}.cls-37,.cls-45,.cls-46,.cls-47,.cls-50,.cls-52{stroke-miterlimit:10;}.cls-38{clip-path:url(#clip-path-3);}.cls-39,.cls-46{fill:#272b2e;}.cls-40{fill:#303335;}.cls-41{fill:#55595b;}.cls-42{fill:#cc5a52;}.cls-43{fill:#414649;}.cls-44{fill:#434749;}.cls-45{stroke-width:6px;}.cls-46{stroke:#0f1011;}.cls-46,.cls-47,.cls-52{stroke-width:2px;}.cls-48{clip-path:url(#clip-path-4);}.cls-49{fill:url(#D\xE9grad\xE9_sans_nom_84);}.cls-50{stroke:#232728;fill:url(#D\xE9grad\xE9_sans_nom_84-2);}.cls-51{fill:#57595b;}.cls-52{stroke:#4e5254;}.cls-53{fill:#97675e;}.cls-54{fill:#173856;}.cls-55{fill:#20456e;}.cls-56{fill:#82cec4;}.cls-57{fill:#282b2e;}.cls-58{fill:url(#D\xE9grad\xE9_sans_nom_31);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_82",
    x1: 347.41,
    y1: 1423.97,
    x2: 2714,
    y2: 1423.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d3236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#31363b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#40444b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#494c55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#4c4f58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_39",
    x1: 1501.78,
    y1: 122.41,
    x2: 1501.78,
    y2: 804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7b8282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8a9191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#a3abab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#b6c0bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#c4cecd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#ccd6d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ced9d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_22",
    x1: 1501.78,
    y1: 1118.49,
    x2: 1501.78,
    y2: 801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5596aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#234c69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_61",
    x1: 1866.78,
    y1: 208,
    x2: 1866.78,
    y2: 843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#8e9696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#979f9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#b3bdbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#cad5d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#dce8e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#e9f5f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#f0fdfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2fffe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_22-2",
    x1: 1889.56,
    y1: 680,
    x2: 1889.56,
    y2: 844,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_22-3",
    x1: 1792.78,
    y1: 664,
    x2: 1792.78,
    y2: 844,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_40",
    x1: 1792.78,
    y1: 196,
    x2: 1792.78,
    y2: 680,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7b8282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#8a9191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#afb8b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#c6d0cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ced9d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_61-2",
    x1: 738,
    x2: 738,
    gradientTransform: "matrix(-1, 0, 0, 1, 1827.78, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_22-4",
    x1: 760.78,
    y1: 680,
    x2: 760.78,
    y2: 844,
    gradientTransform: "matrix(-1, 0, 0, 1, 1827.78, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_22-5",
    x1: 664,
    y1: 664,
    x2: 664,
    y2: 844,
    gradientTransform: "matrix(-1, 0, 0, 1, 1827.78, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_40-2",
    x1: 664,
    x2: 664,
    y2: 680,
    gradientTransform: "matrix(-1, 0, 0, 1, 1827.78, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_61-3",
    x1: 1553,
    y1: 207,
    x2: 1553,
    y2: 842,
    gradientTransform: "matrix(-1, 0, 0, 1, 1827.78, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_22-6",
    x1: 1575.78,
    y1: 679,
    x2: 1575.78,
    y2: 843,
    gradientTransform: "matrix(-1, 0, 0, 1, 1827.78, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_22-7",
    x1: 1479,
    y1: 663,
    x2: 1479,
    y2: 843,
    gradientTransform: "matrix(-1, 0, 0, 1, 1827.78, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_40-3",
    x1: 1506.5,
    y1: 178,
    x2: 1506.5,
    y2: 664,
    gradientTransform: "matrix(-1, 0, 0, 1, 1827.78, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_61-4",
    x1: 792,
    y1: 206,
    x2: 792,
    y2: 841,
    gradientTransform: "translate(1881.78)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_22-8",
    x1: 842.28,
    y1: 678,
    x2: 842.28,
    y2: 842,
    gradientTransform: "translate(1881.78)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_22-9",
    x1: 745.5,
    y1: 662,
    x2: 745.5,
    y2: 841,
    gradientTransform: "translate(1881.78)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_40-4",
    x1: 745.5,
    y1: 177,
    x2: 745.5,
    y2: 678,
    gradientTransform: "translate(1881.78)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_95",
    x1: 2204.99,
    y1: 1887.68,
    x2: 2204.99,
    y2: 1572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#2d3236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c4f58"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(1.78)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1205,1691s17,199,22,224,10,109,62,179,93,102,220,100,151-26,209-96,81-399,81-399Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_109",
    x1: 1502,
    y1: 2194.09,
    x2: 1502,
    y2: 1691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#272b2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#292d31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#32353a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#3f4249"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c4f58"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(1.78)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M401,1541s-42-22-50-79-7-114,50-153,79-30,140-41,191-53,295-55,222,2,302,48c15,10,36,11,59,5,36-15,41-71,77-89,16-9,117-33,234-33s237,22,250,28,21,22,26,33,14,33,18,41,4,15,12,17,766,23,795,33,47,22,57,33,48,55,48,96c0,18.44-3,52-8,63s-13,20-17,32-19,23-23,27-47,51-76,56-531-8-602,15-114,76-189,81-557,8-583,0-21-16-26-32-6-43-25-64Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_96",
    x1: 1530.71,
    y1: 1703.94,
    x2: 1530.71,
    y2: 1144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d3236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#31363b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#40444b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#494c55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#4c4f58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72757d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_101",
    x1: 1506.19,
    y1: 1641.44,
    x2: 1506.19,
    y2: 1128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d3236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#31363b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#40444b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#494c55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#4c4f58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5a5e69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_36",
    x1: 2139,
    y1: 3000,
    x2: 2139,
    y2: 2501.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c3030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3d4146"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#484b53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c4f58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_36-2",
    x1: 585.7,
    x2: 585.7,
    y2: 2550.51,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_80",
    x1: 1500,
    y1: 357,
    x2: 1500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b8b8b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#adadad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9f9f9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#949494"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(1.78)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1091.5,1426.5c-5-10-99-211-328-200-226.62,10.89-338,219-338,219s-71,99-59,254c8.17,105.49,70,201,165,245s276,70,443-77S1145.5,1530.5,1091.5,1426.5ZM763.05,1296.36c192-9.14,270.86,158,275,166.3,10.22,19.52,15.74,44.48,17,72.41-12.92,7.08-30.94,15.91-43.07,17.93-18,3-55-22-55-22s-76-49-165-56-162,25-175,30-82,39-110,37-33-13-39-30c-1.92-5.43.76-14.63,5.29-24.64,3.86-5.83,6.33-8.91,6.33-8.91S573,1305.41,763.05,1296.36Zm-332,399.32c3.62-19,17-29.57,21.91-31.68,7-3,67-25,88,47s83,89,96,103c20.39,22,14,72,6,83-3.18,4.38-8.58,8.59-13.93,12.09a273.53,273.53,0,0,1-45.57-15.59C535.48,1872.09,447.64,1793.26,431.09,1695.68ZM933,1828c-55.81,44.08-110.1,69.08-160.27,80.93-10.32-20.33-40-107,23.27-135.93,81-37,111-91,120-103s66-37,98-33c14.74,1.84,3,51,10,59.66C1003,1748,972,1795.64,933,1828Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4",
    transform: "translate(1.78)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2128,1748s20-44,19-73h152s-5,63-22,73Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_84",
    x1: 2213.5,
    y1: 1748,
    x2: 2213.5,
    y2: 1675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d3236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#3e4248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c4f58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_84-2",
    x1: 2219.26,
    y1: 1717.25,
    x2: 2219.26,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_31",
    x1: 416.8,
    y1: 1560.32,
    x2: 416.8,
    y2: 1039.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#97675e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#90635b",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#624a47",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#413839",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#2e2e30",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282b2e"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "int\xE9rieur voiture  garage") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_8",
    "data-name": "Calque 8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1.78 804 3001.78 801 3001.78 122.41 1.78 191.49 1.78 804"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1.78 1118 1.78 804 3001.78 801 3001.78 1118.49 2438.5 1118.4 1.78 1118"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1860.78 853 1920.78 853 2299.91 1118.49 2185.93 1118.49 1860.78 853"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1089.91 853 1029.91 853 650.78 1118.49 764.75 1118.49 1089.91 853"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1.78 1118 3001.78 1118 3001.78 1058 0 1058 1.78 1118"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1824.78 843 1946.78 843 1972.78 218 1824.78 208 1760.78 208 1760.78 801.24 1824.78 843"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1824.78 680 1954.34 680 1947.78 844 1824.78 844 1824.78 680"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1760.78 804 1760.78 664 1824.78 680 1824.78 844 1760.78 804"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1824.78 680 1824.78 196 1760.78 215.14 1760.78 664 1824.78 680"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1131.78 843 1009.78 843 983.78 218 1131.78 208 1195.78 208 1195.78 801.24 1131.78 843"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "1131.78 680 1002.22 680 1008.78 844 1131.78 844 1131.78 680"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "1195.78 804 1195.78 664 1131.78 680 1131.78 844 1195.78 804"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "1131.78 680 1131.78 196 1195.78 215.14 1195.78 664 1131.78 680"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "316.78 842 194.78 842 168.78 217 316.78 207 380.78 207 380.78 800.24 316.78 842"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "316.78 679 187.22 679 193.78 843 316.78 843 316.78 679"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "380.78 803 380.78 663 316.78 679 316.78 843 380.78 803"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "261.78 664 261.78 178 380.78 214.14 380.78 663 261.78 664"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "2686.78 841 2753.78 841 2779.78 216 2631.78 206 2567.78 206 2567.78 799.24 2686.78 841"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "2686.78 678 2761.34 678 2754.78 842 2686.78 841 2686.78 678"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "2567.78 802 2567.78 662 2686.78 678 2686.78 841 2567.78 802"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "2686.78 678 2686.78 177 2567.78 213.14 2567.78 662 2686.78 678"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1.78,
    y: 1118,
    width: 3000,
    height: 411
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M0,2721l382-778,85-518,2154,109s15,487,27,491,352,265,352,265v710H0Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "522.78 1271 468.78 1296 463.78 1204 1.78 680 1.78 441 652.78 1226 2393.78 1235 3001.78 466 3001.78 731 2600.78 1295 2471.78 1267 522.78 1271"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1024,1223.12l229-.12,524-31.73S2163,1223,2216,1223s157.13,1.62,176,12c20,11,23,23,59,29s81,9,105,13,65,30,65,30l-1544,44Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2663,1318l337,82v908s-316-169-325-250S2663,1318,2663,1318Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M365,1322,0,1446-1,2570.32S389,2024,398,1943,365,1322,365,1322Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2556,1979s-3-661,23-753,135-206,135-206l286-289V890s-314,307-318,377c-2.37,41.47-25,456-7,751,2.67,43.74,295,231,325,272v141s-229-178-286-221S2579,2098,2556,1979Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M493,1923s0-640-26-732S315,983,315,983L0,680-.17,856S260,1063,347,1226c16.34,92.25,17,518,0,717-5.34,62.48-347,545-347,615v206s309.72-488.11,347-549C407,2117,470,2042,493,1923Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M0,441s602,718,651,750,87,60,164,57,1577-22,1577-22l607.89-760.09L3000,321s-881-86-1419-86S372,209,0,317l-.15,2.8C-3.9,392.26,0,441,0,441Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M0,1720s341-152,365-216,69-155,66-213c-19-80-18-92-27-112s-13-35-29-57C350.8,1088.72,0,751,0,751Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M3000,1565s-235-93-250-103-75.66-57.26-94-79c-27-32-31-143,0-186,10.53-14.6,90-109,90-109l254-244Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1779,1887.68s537-4.68,577-16.68,275-299,275-299l-830,32Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1205,1691s17,199,22,224,10,109,62,179,93,102,220,100,151-26,209-96,81-399,81-399Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1205,1667s19,122,80,158,390.74,19.67,424,12c78-18,101-191,101-191Z",
    transform: "translate(1.78)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M401,1541s-42-22-50-79-7-114,50-153,79-30,140-41,191-53,295-55,222,2,302,48c15,10,36,11,59,5,36-15,41-71,77-89,16-9,117-33,234-33s237,22,250,28,21,22,26,33,14,33,18,41,4,15,12,17,766,23,795,33,47,22,57,33,48,55,48,96c0,18.44-3,52-8,63s-13,20-17,32-19,23-23,27-47,51-76,56-531-8-602,15-114,76-189,81-557,8-583,0-21-16-26-32-6-43-25-64Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M401,1541s-42-22-50-79-7-114,50-153,79-30,140-41,191-53,295-55,222,2,302,48c15,10,36,11,59,5,36-15,23-57,59-75,16-9,135-47,252-47s237,22,250,28,21,22,26,33,14,33,18,41,4,15,12,17,766,23,795,33,47,22,57,33,48,55,48,96c0,18.44-3,52-8,63s-13,20-17,32-19,23-23,27-47,51-76,56-531-8-602,15-114,76-189,81-557,8-583,0-21-16-26-32-6-43-25-64Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1169,1478V1364a73.52,73.52,0,0,1-2-48c8-26,22-40,35-45,7-13,13.25-15.56,18.12-26.78S1241,1169,1244,1169s256-41,256-41l277,38,19.42,67.7s5.78,20.14,12.68,26.72S1831,1278,1835,1289s18,69,12,113-10,112-10,112-2,21-10,34-16.18,20.75-19,23c-5,4-16,10-25,13-7,11-67.65,43.93-77,48-23,10-138,8-169,9s-190,0-190,0-19,2-49-13-96-54-96-54-25-17-30-40-4-43-3-48A16.94,16.94,0,0,0,1169,1478Z",
    transform: "translate(1.78)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1278,3000s0-150,25-235,94-173,197-212,335-56,491,0c0-81,508-44,586-36s202,33,251,71,151,230,172,350v62Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1147,3000s28-128,24-214-1-131-81-157-111-39-147-58-457.21-39.64-616.11,12.68S0,3000,0,3000Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M0,357S500,226,1500,237,3000,355,3000,355V0H0Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 1248.78,
    y: 1296,
    width: 512,
    height: 233
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1091.5,1426.5c-5-10-99-211-328-200-226.62,10.89-338,219-338,219s-71,99-59,254c8.17,105.49,70,201,165,245s276,70,443-77S1145.5,1530.5,1091.5,1426.5ZM763.05,1296.36c192-9.14,270.86,158,275,166.3,10.22,19.52,15.74,44.48,17,72.41-12.92,7.08-30.94,15.91-43.07,17.93-18,3-55-22-55-22s-76-49-165-56-162,25-175,30-82,39-110,37-33-13-39-30c-1.92-5.43.76-14.63,5.29-24.64,3.86-5.83,6.33-8.91,6.33-8.91S573,1305.41,763.05,1296.36Zm-332,399.32c3.62-19,17-29.57,21.91-31.68,7-3,67-25,88,47s83,89,96,103c20.39,22,14,72,6,83-3.18,4.38-8.58,8.59-13.93,12.09a273.53,273.53,0,0,1-45.57-15.59C535.48,1872.09,447.64,1793.26,431.09,1695.68ZM933,1828c-55.81,44.08-110.1,69.08-160.27,80.93-10.32-20.33-40-107,23.27-135.93,81-37,111-91,120-103s66-37,98-33c14.74,1.84,3,51,10,59.66C1003,1748,972,1795.64,933,1828Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M454,1522s-14.38,22.84-11.19,50.42S458,1604,467,1608s62-2,83,32,44,116,137,114,182-87,203-131c39-34,48-11,75-11s90-17.93,90-36v-44l-358-69Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M475,1500s-24,7-21,22,10,29,29,31,36,6,94-21,109-42,146-43,150,9,200,45,75,40,87,38,45-31,45-31l-.64-10.78L1002,1503l-302-70Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M431,1433l23-68,162.76-114.54L795,1207l198,54,113,158,16,64s-30-49-50-74-57.75-98.67-135-133c-45-20-124-47-209-35s-164,63-208,102C486.13,1373,459,1406,431,1433Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M432.5,1690.08S428,1694,428,1708s35,110.09,73,142,94,67,120,67c15-13,20-23,20-23Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M773,1900s0,17,3,19,71-22,101-38,94-71,110-92,50-70,49-94-6-54-12-55-22,0-22,0Z",
    transform: "translate(1.78)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1279,1248h449s-6-43-41-57-323-17-357,0S1279,1248,1279,1248Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "1318.78 1784 1321.78 1748 1386.78 1748 1386.78 1784 1318.78 1784"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-39",
    cx: 1686.28,
    cy: 1774.5,
    rx: 22.5,
    ry: 15.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-39",
    cx: 1686.28,
    cy: 1765.5,
    rx: 22.5,
    ry: 15.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M1707,1765.5c0,8.56-10.07,15.5-22.5,15.5s-22.5-6.94-22.5-15.5c0-4.28,11.75,4.5,23,4.5S1707,1761.22,1707,1765.5Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "1510.78 1748 1627.78 1748 1634.78 1784 1510.78 1784 1510.78 1748"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 1510.78,
    y: 1784,
    width: 124,
    height: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "1510.78 1779 1633.78 1779 1634.78 1784 1510.78 1784 1510.78 1779"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 1319.78,
    y: 1744,
    width: 308,
    height: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "1319.78 1748 1315.78 1789 1318.78 1787 1318.78 1784 1321.78 1748 1319.78 1748"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "1315.78 1789 1318.78 1787 1634.78 1788 1634.78 1784 1627.78 1748 1627.78 1744 1638.78 1790 1315.78 1789"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 1319.78,
    y: 1744,
    width: 308,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M1247,1701.57s22,95.43,73,103.43,363,17,393,0,46-101,46-101",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-46",
    cx: 1362.63,
    cy: 1572.09,
    rx: 22.5,
    ry: 23.18,
    transform: "translate(-20.81 19.86) rotate(-0.83)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M1385.13,1571.77c.18,12.8-9.74,23.32-22.17,23.5s-22.64-10-22.83-22.85c-.09-6.4,11.85,6.56,23.1,6.39S1385,1565.37,1385.13,1571.77Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-46",
    cx: 1655.63,
    cy: 1571.09,
    rx: 22.5,
    ry: 23.18,
    transform: "translate(-20.76 24.1) rotate(-0.83)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M1678.13,1570.77c.18,12.8-9.74,23.32-22.17,23.5s-22.64-10-22.83-22.85c-.09-6.4,11.85,6.56,23.1,6.39S1678,1564.37,1678.13,1570.77Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 1403.78,
    y: 1594,
    width: 224,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 1403.78,
    y: 1594,
    width: 37.33,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 1441.11,
    y: 1594,
    width: 37.33,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 1478.44,
    y: 1594,
    width: 37.33,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 1515.78,
    y: 1594,
    width: 37.33,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 1553.11,
    y: 1594,
    width: 37.33,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 1590.44,
    y: 1594,
    width: 37.33,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 1972.78,
    y: 1351,
    width: 619,
    height: 178,
    rx: 12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-47",
    x1: 2060.17,
    y1: 1440,
    x2: 2506.47,
    y2: 1440
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M2128,1748s20-44,19-73h152s-5,63-22,73Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2278,1751s-4-8-6-21,9-77,9-77l25,20-17,80Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M2139.53,1717.25c2.58,0,152.74,0,152.74,0s3.23-12.75,6.73-42.25H2147S2148,1693,2139.53,1717.25Z",
    transform: "translate(1.78)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "2279.28 1748.5 2129.78 1748 2130.28 1746.5 2280.78 1747 2279.28 1748.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M1212,1764.57s24.88,95.43,82.55,103.43,410.5,17,444.43,0,52-101,52-101",
    transform: "translate(1.78)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "personnages"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M144.75,1819.81s13.47-312.08-6.73-381.68-39.3-259.33-55-344.64c0-134.72,95.87-302,206.56-346.89,130.22-52.76,290.75-40.41,368.21,26.94S780.15,933,782.39,985.72s19,479.19,1,519.6-32.55,43.78-65.11,47.15-155.92,17-155.92,17L550,1819.81Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1055,3000l36-384s-20.78-243.42-98-271c-84-30-344,0-344,0l262,655Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M0,1710c68.12-10.09,145.87-19.29,145.87-19.29s-13.47,46,30.31,66.24,317.7,33.67,354.75,19.08,20.2-30.31,20.2-30.31S777.27,1794.49,823,1844c109,118,133.77,307.72,141,368,9,75,91,788,91,788H0S-1,1793,0,1710Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M83,1730c18,40.42,174,101,287.38,89.81s233.51-15.71,253.71-38.17,25.07-21.16,25.07-21.16-29.56-79.87-67.73-91.1-108.89,20.21-227.88,35.93c-26.81,3.54-233.51,7.85-204.46-68.38C129,1651.42,65.05,1689.59,83,1730Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M83,1093.49s-32.56-11.23-40.42-53.89,0-52.76,20.21-64c-15.72-25.82-12.35-35.92-1.12-44.9C50.45,922.85,28,874.58,76.27,851c0-21.33,16.84-32.55,31.44-23.57C101,783.65,122.3,759,159.34,759c-6.73-20.21,18-53.89,49.4-56.13,0-24.7,29-71.29,72.31-56.41,14.13-42.38,65.77-43.5,89.34-34.52,0-22.45,59.5-55,88.69-29.19C472.55,567,527.56,546.78,564.61,604c41.53-22.45,87.56-25.82,104.4,32.56,0,0,59.5-12.35,60.62,50.51,33.68-3.37,52.76,70.73,28.06,80.83,48.28,21.33,34.8,62.87,25.82,78.58,34.8,14.6,33.68,62.87,19.09,83.08C826.17,961,777.9,988,777.9,988s-1.12,44.91-46,84.2c0,0-74.09,26.94-143.69,11.22C546.26,1073.92,163.84,1206.87,83,1093.49Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M83,1093.49C80.5,1090.84,118,1354,132,1415c14,40,15.13,96.47,15.36,106.76,41.17-.56,284.78,75.78,336.42,15.16,32.55-75.22,124.61-117.88,119-197.58s12.35-171.76,78.59-170.64c21.33,14.59,21.33,57.25,21.33,57.25s0,24.7,24.69,0c0-42.66-12.35-88.6,12.35-111.13s0-75.11,0-75.11Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "758.48 3000 713.78 2502 793.39 3000 758.48 3000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterieurVoitureGarage);
export default __webpack_public_path__ + "static/media/interieur_voiture_garage.a1aef7d755c1011db7b955bd3a9f1df9.svg";
export { ForwardRef as ReactComponent };